import React from 'react'
import { useQuery } from 'react-query'
import { Spinner, Icon } from '@blueprintjs/core'
import { MonacoDiffEditor } from 'react-monaco-editor'
import { taskScrapeConfigQuery } from 'ui-io/queries/tasks/task-scrape-config-query'
import { scrapeConfigQuery } from 'ui-io/queries/configs/scrape-config-query'
import { useDarkMode, useToggle, JsonDialog } from 'ui-components'
import styled from 'styled-components'

// import JsonDialog from '../../components/json-dialog'

const ConfigDiffForm = ({
  taskId,
  configId,
}: {
  taskId: string
  configId?: string
}) => {
  const [jsonDialogToggle, setJsonDialogToggle] = useToggle()
  const [darkMode] = useDarkMode()

  const taskConfig = useQuery(
    !taskId ? { enabled: false } : taskScrapeConfigQuery({ taskId: taskId }),
  )
  const brandConfig = useQuery(
    !configId
      ? { enabled: false }
      : scrapeConfigQuery({ configId: configId }),
  )
  return (
    <>
      {taskConfig.isLoading || brandConfig.isLoading ? (
        <Spinner />
      ) : (
        brandConfig.data?.configuration &&
        taskConfig.data &&
        (jsonDialogToggle ? (
          <JsonDialog
            title={brandConfig.data?.brand as string}
            isDialogOpen={jsonDialogToggle}
            onDialogClose={setJsonDialogToggle}
            height="700px"
          >
            <MonacoDiffEditor
              language="json"
              theme={darkMode ? 'vs-dark' : 'vs'}
              height="700"
              options={{ automaticLayout: true, readOnly: true }}
              original={JSON.stringify(
                brandConfig.data?.configuration,
                null,
                2,
              )}
              value={JSON.stringify(taskConfig.data, null, 2)}
            />
          </JsonDialog>
        ) : (
          <PositionDiv>
            <CustomExpendIcon>
              <Icon icon="fullscreen" onClick={setJsonDialogToggle} />
            </CustomExpendIcon>

            <MonacoDiffEditor
              language="json"
              theme={darkMode ? 'vs-dark' : 'vs'}
              height="300"
              options={{ automaticLayout: true, readOnly: true }}
              original={JSON.stringify(
                brandConfig.data?.configuration,
                null,
                2,
              )}
              value={JSON.stringify(taskConfig.data, null, 2)}
            />
          </PositionDiv>
        ))
      )}
    </>
  )
}
export default ConfigDiffForm

const PositionDiv = styled.div`
  position: relative;
`

const CustomExpendIcon = styled.div`
  position: absolute;
  right: 6%;
  z-index: 111;
  cursor: pointer;
`
